import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register(
  'post-behavior-history',
  class extends Controller {
    connect () {
      this.sendRequest()
    }

    sendRequest () {
      let payload
      try {
        const payloadString = this.data.get('payload')
        payload = payloadString ? JSON.parse(payloadString) : {}
      } catch {
        payload = {}
      }

      const requestBody = {
        behavior_history: {
          url: window.location.href,
          event_type: this.data.get('eventType'),
          user_agent: navigator.userAgent || 'Unknown',
          payload: payload
        }
      }

      fetch('/public_api/behavior_histories', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify(requestBody)
      })
    }
  }
)
